import { requests } from '../httpClient';

export const CardSubscription = {
    getCardSubscriptionAsync: () => requests.get(`CardSubscription`),
    deleteCardSubscriptionAsync: (id: string) => requests.delete(`CardSubscription/${id}`)
};
